import { render, staticRenderFns } from "./ScanBJWL.vue?vue&type=template&id=36671334&scoped=true"
import script from "./ScanBJWL.vue?vue&type=script&lang=js"
export * from "./ScanBJWL.vue?vue&type=script&lang=js"
import style0 from "./ScanBJWL.vue?vue&type=style&index=0&id=36671334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36671334",
  null
  
)

export default component.exports